const selectBtns = {
	all: document.querySelector('.js_modelSelect-all'),
	parents: document.querySelectorAll('.js_modelSelect-parent'),
	children: document.querySelectorAll('.js_modelSelect'),
};
const modelItems = document.querySelectorAll('[data-model]');
const modelListArea = document.querySelector('.modelListArea');

const modelSort = function (targets) {
	modelItems.forEach((el) => {
		if (targets.includes(el.getAttribute('data-model'))) {
			el.classList.add('show');
		} else {
			el.classList.remove('show');
		}
	});
};

const allCheck = function () {
	selectBtns.all.checked = true;
	selectBtns.parents.forEach((el) => {
		el.checked = false;
	});
	selectBtns.children.forEach((el) => {
		el.checked = false;
	});
}

const allShow = function () {
	modelItems.forEach((el) => {
		el.classList.add('show');
	});
};

const all = function () {
	allCheck();
	modelListArea.classList.add('changing');
	clearTimeout(timer);
	timer = setTimeout(() => {
		allShow();
		modelListArea.classList.remove('changing');
	}, 1000);
}

const getChecked = function () {
	const arr = [];
	let i = 0;
	selectBtns.children.forEach((el) => {
		if (el.checked) {
			arr[i] = el.value;
			i++;
		}
	});
	if (arr.length === 0) {
		all();
		return false;
	}
	return arr;
};

let timer;

const itemChange = function () {
	selectBtns.all.checked = false;
	const checkedCats = getChecked();
	if (!checkedCats) {
		return false;
	}
	modelListArea.classList.add('changing');
	clearTimeout(timer);
	timer = setTimeout(() => {
		modelSort(checkedCats);
		modelListArea.classList.remove('changing');
	}, 1000);
};

selectBtns.children.forEach((el) => {
	el.addEventListener('change', () => {
		const parentList = el.closest('.js_sortList');
		const parent = parentList.querySelector('.js_modelSelect-parent');
		const children = parentList.querySelectorAll('.js_modelSelect');
		const checkedChildren = parentList.querySelectorAll('.js_modelSelect:checked');
		parent.checked = children.length === checkedChildren.length;
		itemChange();
	}, false);
});

selectBtns.all.addEventListener('click', all, false);

selectBtns.parents.forEach((el) => {
	el.addEventListener('change', () => {
		const children = el.closest('.js_sortList').querySelectorAll('.js_modelSelect');
		children.forEach((child) => {
			child.checked = el.checked;
		});
		itemChange();
	}, false);
});

const sortMoreBtn = document.getElementById('sortMoreBtn');
